import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { SharedModule } from '../../shared/shared.module';
import { SpinnerModule } from '@app/layout/spinner/spinner.module';
import { ErroRequisicaoModule } from '@app/layout/erro-requisicao/erro-requisicao.module';


const routes: Routes = [
  { path: '', component: HomeComponent },
];

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    RouterModule.forChild(routes),
    SpinnerModule,
    ErroRequisicaoModule
  ],
  declarations: [
    HomeComponent
  ]
})
export class HomeModule { }
